import { useGetBusinessReportsQuery } from "../businessReports.api";
import { BusinessReport, BusinessReportPrompt } from "@/modules/snapshots/businessReports.types";
import React from "react";
import { BusinessReportsPageGenerate } from "./generate";
import { BusinessReportRow } from "./businessReportRow";
import { BusinessReportDetails } from "./businessReportDetails";
import { useParams, useSearchParams } from "react-router";
import { ReportsLayoutContent } from "../generate/layout";
import { useGetFileDetailsQuery } from "@/api/files";
import { flatFileSystem } from "@/components/feature/layout/left-sidebar/helpers";
import { useCurrentPdf } from "@/views/chat/hooks/useCurrentPdf";

const emptyList: BusinessReport[] = [];

export const BusinessReportGenerateView: React.FC = () => (
  <ReportsLayoutContent>
    <BusinessReportGenerate />
  </ReportsLayoutContent>
);
export const BusinessReportGenerate: React.FC = () => {
  const { data: businessReports = emptyList } = useGetBusinessReportsQuery();
  const [prompts, setPrompts] = React.useState<BusinessReportPrompt[]>([]);
  const { fseId } = useParams<{ fseId: string }>();
  const { data } = useGetFileDetailsQuery({ fse_id: fseId });
  const [searchParams] = useSearchParams();
  const { setSelectedFiles } = useCurrentPdf();
  const businessReportId = searchParams.get("businessReport");

  const fsEntries = data ? flatFileSystem(data, 0, new Set(), false) : [];

  React.useEffect(() => {
    setSelectedFiles(fsEntries.map(row => row.id));
  }, []);

  const [selectedBusinessReport, setSelectedBusinessReport] = React.useState<BusinessReport | null>(null);

  const handleTemplateSelect = (businessReport: BusinessReport) => {
    setSelectedBusinessReport(businessReport);
  };

  React.useEffect(() => {
    if (businessReportId) {
      const selectedBusinessReport = businessReports.find(businessReport => businessReport.id === businessReportId);
      if (selectedBusinessReport) {
        setSelectedBusinessReport(selectedBusinessReport);
      }
    }
  }, [businessReports, businessReportId]);

  React.useEffect(() => {
    if (selectedBusinessReport) {
      setPrompts(selectedBusinessReport.prompts);
    }
  }, [selectedBusinessReport]);

  return (
    <>
      <div className="flex flex-grow flex-col overflow-y-auto p-6 pt-0">
        {selectedBusinessReport && !!fsEntries.length && (
          <BusinessReportsPageGenerate
            prompts={prompts}
            fsEntries={fsEntries}
            selectedBusinessReport={selectedBusinessReport}
          />
        )}

        <div className="flex flex-grow rounded-lg bg-white p-6 shadow">
          <div className="flex flex-grow">
            <div className="w-1/3 flex-grow border-r pr-4">
              <h2 className="mb-4 text-xl font-bold">Templates</h2>
              {businessReports.map(businessReport => (
                <BusinessReportRow
                  key={businessReport.id}
                  businessReport={businessReport}
                  selectedBusinessReport={selectedBusinessReport}
                  handleTemplateSelect={handleTemplateSelect}
                />
              ))}
            </div>
            <div className="w-2/3 flex-grow pl-4">
              {selectedBusinessReport ? (
                <BusinessReportDetails
                  setPrompts={setPrompts}
                  prompts={prompts}
                  businessReport={selectedBusinessReport}
                />
              ) : (
                <p>Select a template to view details and prompts.</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
